// removed by extract-text-webpack-plugin
module.exports = {"logo":"cgng0Ea-tL8oapT2by0rV"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Logo/Logo.css
// module id = 1121
// module chunks = 58